import { render, staticRenderFns } from "./DeliverySchedule.vue?vue&type=template&id=64f0631b"
import script from "./DeliverySchedule.vue?vue&type=script&lang=js"
export * from "./DeliverySchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f0631b')) {
      api.createRecord('64f0631b', component.options)
    } else {
      api.reload('64f0631b', component.options)
    }
    module.hot.accept("./DeliverySchedule.vue?vue&type=template&id=64f0631b", function () {
      api.rerender('64f0631b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flowControl/DeliverySchedule.vue"
export default component.exports